<report-filter
  showCostCenters='true'
  showFacilities='true'
  showPeriodEndDateSelection='true'
  showShiftBlocks='true'
  defaultPayPeriodsBack=1
  showViews='true'
  reportType='ancillary'
  ancillaryType='total'
  [(views)]="views"
  [defaultView] = "defaultView"
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)">
</report-filter>

<smt-measures-report
  [filtersUpdated]='filterEventsSubject.asObservable()'
  [toggleReportClicked]='toggleReportEventsSubject.asObservable()'
  (staffingDataUpdated)='staffingDataUpdated($event)'
  [(reportFilters)]='filters'
  [showReport]='showReport'
  >
</smt-measures-report>

<report-export-button
  [reportFilters]="filters"
  [exportUrl]="'Measure/GetMeasuresReportExportData'"
  [fileName]="'TotalUOS_Measures_Report'"
  [filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>

<button class='button primary' (click)='toggleReportDisplayed()' >{{ showReport == 'total' ? 'View Average Measures' : 'View Total Measures' }}</button>

<table class='condensed' role='list'>
  <thead>
    <th><!-- empty row for the series names --></th>
    <th *ngFor='let item of staffingData.xAxis'><div>{{item}}&nbsp;&nbsp;</div></th>
  </thead>
  <tr *ngFor='let dataSet of gridData'>
    <td>{{dataSet.name}}</td>
    <td *ngFor='let item of dataSet.data'>{{item}}</td>
  </tr>
</table>
